export const INSUFFICIENT_BOUND = 50

export const LOW_DATA_BOUND = 100

export const DEFAULT_CHART_HEIGHT_IN_PX = 540

export const DIAMETER_MAX_PERCENT = 0.54

export const MIN_DIAMETER_IN_PX = 2
